var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79682 6.98125C9.30909 5.44444 11.3366 5.11542 12.3085 6.41138C12.8779 7.17052 12.8382 8.22458 12.2133 8.93871L11.2941 9.98924C10.4598 10.9427 10 12.1665 10 13.4334V13.75C10 14.1642 10.3358 14.5 10.75 14.5C11.1642 14.5 11.5 14.1642 11.5 13.75V13.4334C11.5 12.5298 11.828 11.657 12.423 10.977L13.3422 9.92647C14.4338 8.67892 14.5032 6.83755 13.5085 5.51138C11.8106 3.24743 8.2687 3.8222 7.37379 6.50691L7.03849 7.51283C6.9075 7.90579 7.11987 8.33053 7.51283 8.46151C7.90579 8.5925 8.33053 8.38013 8.46151 7.98717L8.79682 6.98125Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 0C4.81294 0 0 4.81294 0 10.75C0 16.6871 4.81294 21.5 10.75 21.5C16.6871 21.5 21.5 16.6871 21.5 10.75C21.5 4.81294 16.6871 0 10.75 0ZM1.5 10.75C1.5 5.64137 5.64137 1.5 10.75 1.5C15.8586 1.5 20 5.64137 20 10.75C20 15.8586 15.8586 20 10.75 20C5.64137 20 1.5 15.8586 1.5 10.75Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 16.75C11.75 17.3023 11.3023 17.75 10.75 17.75C10.1977 17.75 9.75 17.3023 9.75 16.75C9.75 16.1977 10.1977 15.75 10.75 15.75C11.3023 15.75 11.75 16.1977 11.75 16.75Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqCircle);
export default __webpack_public_path__ + "static/media/faq-circle.3a8d4e851d1f66c5fef7c3d04c268f49.svg";
export { ForwardRef as ReactComponent };